import { useCallback, useState } from "react";
import { REQUIRED_ANSWER_MESSAGE } from "@/constants/validation-constant";
import { QuestionAnswerTypeEnum } from "@/services";
import { SocialHistoryQuestion } from "../readmission-f2f-types";
import { isGroupValue, SocialStore } from "../readmission-f2f-utils";

export interface UseSocialHistoryValidation {
  /** Set by a Save press with nothing selected; cleared on the next answer. */
  error?: string;
  /** True when the section may be saved. */
  validate: () => boolean;
  clearError: () => void;
}

const isAnswered = (q: SocialHistoryQuestion, store: SocialStore): boolean => {
  const value = store[q.uuid];
  if (!value) return false;
  if (value.freeText.trim()) return true;
  if (q.answerType === QuestionAnswerTypeEnum.Text) return false;
  return isGroupValue(value) ? value.selected.length > 0 : !!value.selected;
};

/** One selection or one typed note anywhere in the section is enough for its own Save to run. */
export const useSocialHistoryValidation = (
  ordered: SocialHistoryQuestion[],
  store: SocialStore
): UseSocialHistoryValidation => {
  const [error, setError] = useState<string>();

  const validate = useCallback(() => {
    const isValid = ordered.some((q) => isAnswered(q, store));
    setError(isValid ? undefined : REQUIRED_ANSWER_MESSAGE);
    return isValid;
  }, [ordered, store]);

  const clearError = useCallback(() => setError(undefined), []);

  return { error, validate, clearError };
};
